export var DisputeReason;
(function (DisputeReason) {
    DisputeReason["INCORRECT_SALE_AMOUNT"] = "INCORRECT SALE AMOUNT";
    DisputeReason["DOUBLE_CHARGE"] = "DOUBLE CHARGE";
    DisputeReason["CREDIT_NOT_POSTED"] = "CREDIT NOT POSTED";
    DisputeReason["CREDIT_POSTED_AS_DEBIT"] = "CREDIT POSTED AS DEBIT";
    DisputeReason["CREDIT_POSTED_DOES_NOT_BELONG_TO_ACCOUNT"] = "CREDIT POSTED DOES NOT BELONG TO ACCOUNT";
    DisputeReason["INCORRECT_CREDIT_AMOUNT"] = "INCORRECT CREDIT AMOUNT";
    DisputeReason["CANCELLED_ORDER_OR_RESERVATION"] = "CANCELLED ORDER OR RESERVATION";
    DisputeReason["CANCELLED_RECURRING_TRANSACTION"] = "CANCELLED RECURRING TRANSACTION";
    DisputeReason["NON_RECEIPT_OF_GOODS_SERVICES"] = "NON-RECEIPT OF GOODS/SERVICES";
    DisputeReason["MERCHANDISE_NOT_RECEIVED"] = "MERCHANDISE NOT RECEIVED";
    DisputeReason["QUALITY_OF_GOODS_SERVICES"] = "QUALITY OF GOODS/SERVICES";
    DisputeReason["PAID_BY_OTHER_MEANS"] = "PAID BY OTHER MEANS";
    DisputeReason["NO_WRITTEN_DISCLOSURES_AT_POS"] = "NO WRITTEN DISCLOSURES AT POS";
    DisputeReason["PROVIDER_MISLED_CUST_ON_TERMS"] = "PROVIDER MISLED CUST ON TERMS";
    DisputeReason["PROVIDER_SUBMITTED_WITHOUT_MY_KNOWLEDGE_CONSENT"] = "PROVIDER SUBMITTED WITHOUT MY KNOWLEDGE/CONSENT";
    DisputeReason["MULTIPLE_REASONS_DISPUTES"] = "MULTIPLE REASONS DISPUTES";
})(DisputeReason || (DisputeReason = {}));
//# sourceMappingURL=disputeReason.js.map